import React, { Component } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import KpsEditor from "../editor/KpsEditor";
import { Trans, withTranslation } from "react-i18next";
import axios, { discussionClient } from "../../AxiosClient";
import KpsDialog from "../kps-dialog/KpsDialog";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { withSnackbar } from "notistack";
import { containsScriptOrSVG, containsBadCharacter } from "../../utils/ContentChecker";
import {
  setGlobalAlert
} from "../../redux/actions/universalActions";

const styles = (theme) => ({});
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
export class CreateEntry extends Component {
  static propTypes = {};
  constructor(props) {
    super(props);
    this.state = {
      discussionText: "",
      // slateRef: null,
      text: "",
      title: "",
      width: 450,
      height: 650,
      attachmentIds: [],
      openSnackbar: false,
      edited: false,
      saving: false,
    };
    this.slateChange = this.slateChange.bind(this);
  }
  render() {
    const { classes } = this.props;
    return (
      <>
        <KpsDialog
          top={this.props.top}
          open={this.props.open}
          resize={(width, height) => this.setState({ width, height })}
          width={this.state.width}
          height={this.state.height}
          title={
            this.props.edit ? (
              <Trans i18nKey="edit_entry_header" />
            ) : (
              <>
                {/* <Trans i18nKey="create_entry_header" /> */}
                <>
                {(this.props.discussion.expert === false || 
                  (this.props.discussion.expertQuestionVisibility != null && 
                    this.props.discussion.expertQuestionVisibility.toLowerCase().indexOf("public") > -1)) ?
                    <Trans i18nKey="create_public_entry_header" />
                    :
                    <Trans i18nKey="create_expert_entry_header" />
                }
                </>
              </>
            )
          }
          accept={this.saveEntry}
          loading={this.state.saving}
          close={this.props.changeOpenCreateEntry}
        >
          {this.props.open && (
            <KpsEditor
              updateUploadArray={this.updateUploadArray}
              onChange={this.slateChange}
              ref="slate"
              newUploadId={this.newUploadId}
              height={this.state.height - 168}
              width={this.state.width - 48}
              initialContent={this.props.edit && this.props.entry.text}
              resize={false}
            />
          )}
        </KpsDialog>
      </>
    );
  }

  updateUploadArray = (array) => {
    let newArray = [];
    for (let i = 0; i < array.length; i++) {
      newArray.push(Number(array[i]));
    }
    this.setState({ attachmentIds: newArray });
  };
  newUploadId = (response) => {
    let attachments = this.state.attachmentIds.splice(0);
    attachments.push(Number(response));
    this.setState({ attachmentIds: attachments });
  };
  slateChange = (event) => {
    this.setState({ text: event });
  };
  getValues() {
    let entry = {};
    entry.text = this.state.text;
    entry.userId = this.props.user.id;
    entry.attachmentIds = this.state.attachmentIds;
    return entry;
  }
  saveEntry = () => {
    if (containsScriptOrSVG([this.state.text])) {
      this.props.setGlobalAlert({type:"error", message:"harmful_content", open:true})
      return;
    } else if (containsBadCharacter([this.state.text])){
      this.props.setGlobalAlert({type:"error", message:"unusable_character", open:true})
      return;
    }
    {
      this.props.edit
        ? discussionClient
          .patch(`/entry/${this.props.entry.entryId}`, {
            ...this.getValues(),
          })
          .then((res) => {
            this.props.enqueueSnackbar(
              this.props.t("edit_entry_success_snackbar"),
              {
                variant: "success",
              }
            );
            this.setState({ edited: true });
            this.props.onEntryEdited(res.data);
            this.props.changeOpenCreateEntry();
          })
          .catch((err) => {
            this.props.enqueueSnackbar(
              this.props.t("edit_entry_error_snackbar"),
              {
                variant: "error",
              }
            );
          })
        : discussionClient
          .post(`/discussion/${this.props.discussion.discussionId}/entry/`, {
            ...this.getValues(),
          })
          .then((res) => {
            this.props.enqueueSnackbar(
              this.props.t("create_entry_success_snackbar"),
              {
                variant: "success",
              }
            );
            this.props.onEntryCreated(res.data);
            this.props.changeOpenCreateEntry();
            this.setState({ saving: false });
          })
          .catch(() => {
            this.props.enqueueSnackbar(
              this.props.t("edit_entry_error_snackbar"),
              { variant: "error" }
            );
            this.setState({ saving: false });
          });
    }
  };
}
const mapStateToProps = (state) => ({
  user: state.user.currentUser,
});
const mapDispatchToProps = {
  setGlobalAlert,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withSnackbar(withTranslation()(CreateEntry))));
